export default "__VITE_ASSET__BmmO5S9K__"